import {TYPES} from '../Actions/coverNoteAction';
import * as moment from 'moment';

const coverNoteReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.FETCH_ALL_COVER_NOTES_SUCCESS:
            return {
                ...state,
                allCoverNotes: action.allCoverNotes
            };
        case TYPES.FETCH_ALL_ARCHIVED_SUCCESS:
            return {
                ...state,
                allArchived: action.allArchived
            };
        case TYPES.FETCH_COVER_NOTE_SUCCESS:
            return {
                ...state,
                coverNote: action.coverNote
            };
        case TYPES.FETCH_COVER_NOTE_COUNT_SUCCESS:
            return {
                ...state,
                coverNoteCount: {
                    value: action.coverNoteCount,
                    updatedAt: moment()
                }
            };
        case TYPES.FETCH_ARCHIVED_COUNT_SUCCESS:
            return {
                ...state,
                archivedCount: {
                    value: action.archivedCount,
                    updatedAt: moment()
                }
            };
        case TYPES.SA_APPLY_COVER_NOTE_SUCCESS:
        case TYPES.IN_APPLY_COVER_NOTE_SUCCESS:
        case TYPES.UPDATE_COVER_NOTE_SUCCESS:
            return {
                ...state,
                cnSummary: action.cnSummary
            };
        case TYPES.IN_CONFIRM_COVER_NOTE_SUCCESS:
            return {
                ...state,
                confirmCnSummary: action.confirmCnSummary
            };
        case TYPES.VOID_COVER_NOTE_SUCCESS:
            return {
                ...state,
                voidCnSummary: action.voidCnSummary
            };
        case TYPES.FETCH_COVER_NOTE_HISTORY_SUCCESS:
            return {
                ...state,
                coverNoteHistory: action.coverNoteHistory
            };
        default:
            return state;
    }
};

export default coverNoteReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/coverNoteReducer.ts